"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const SyntaxHighlighting_1 = __importDefault(require("../SyntaxHighlighting"));
function LoFInput({ style, onChange, highlighting, value, className, }) {
    let setInput;
    if (onChange === undefined) {
        if (value === undefined) {
            throw new Error("If onChange is defined, a value must be provided");
        }
        [value, setInput] = (0, react_1.useState)("hallo welt");
    }
    const inputRef = (0, react_1.useRef)(null);
    const textRef = (0, react_1.useRef)(null);
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ style: Object.assign({ position: "relative", height: "2em" }, style), className: className }, { children: [(0, jsx_runtime_1.jsx)("input", { placeholder: "((a)(b))(c)", ref: inputRef, value: value, style: {
                    paddingLeft: "inherit",
                    position: "absolute",
                    fontSize: "inherit",
                    zIndex: 1,
                    top: "0px",
                    left: "0px",
                    width: "100%",
                    height: "100%",
                    color: "transparent",
                    backgroundColor: "transparent",
                    fontFamily: "inherit",
                    overflowY: "hidden",
                    border: "none",
                    whiteSpace: "nowrap",
                    caretColor: "black",
                }, onKeyUp: () => {
                    // @ts-ignore
                    textRef.current.scrollLeft = inputRef.current.scrollLeft;
                }, onKeyDown: () => {
                    // @ts-ignore
                    textRef.current.scrollLeft = inputRef.current.scrollLeft;
                }, onChange: onChange !== null && onChange !== void 0 ? onChange : ((e) => setInput(e.currentTarget.value)) }), (0, jsx_runtime_1.jsx)("div", Object.assign({ ref: textRef, style: {
                    padding: "2px",
                    paddingLeft: "inherit",
                    zIndex: 0,
                    position: "absolute",
                    fontSize: "inherit",
                    border: "none",
                    fontFamily: "inherit",
                    overflowX: "hidden",
                    width: "100%",
                    height: "100%",
                    maxHeight: "100%",
                    overflowY: "hidden",
                    verticalAlign: "middle",
                    paddingRight: "15px",
                    whiteSpace: "pre" /* Allows textarea to scroll horizontally */,
                    left: "0px",
                    top: "0px",
                } }, { children: (0, jsx_runtime_1.jsx)(SyntaxHighlighting_1.default, Object.assign({ highlighting: highlighting }, { children: value !== null && value !== void 0 ? value : "" })) }))] })));
}
exports.default = LoFInput;
